import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import LoadingFallback from "../../components/elements/LoadingFallback";
import { consumePostLoginRedirect, persistKeycloakTokens } from "../../helpers/keycloakAuth";
import { verifyAuthToken } from "../../services/authService";

const KeycloakCallback = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const hasSyncedRole = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (auth.isLoading) {
        return;
      }

      if (!auth.isAuthenticated) {
        if (auth.error) {
          navigate("/login", {
            replace: true,
            state: { error: auth.error.message },
          });
          return;
        }
        navigate("/login", { replace: true });
        return;
      }

      if (!hasSyncedRole.current) {
        hasSyncedRole.current = true;

        persistKeycloakTokens(auth.user);

        const internalRole = auth.user?.state?.internalRole;
        const organizationId = auth.user?.state?.organizationId;

        if (internalRole) {
          try {
            await verifyAuthToken({
              internalRole,
              ...(organizationId ? { organizationId } : {}),
            });
          } catch (error) {}
        }
      }

      const redirectTo = consumePostLoginRedirect("/");
      navigate(redirectTo, { replace: true });
    };

    run();
  }, [auth.isLoading, auth.isAuthenticated, auth.error, auth.user, navigate]);

  return <LoadingFallback />;
};

export default KeycloakCallback;
